import React, { type ChangeEvent } from 'react';

import { Button, Typography } from '@pkg/components';

import { type Weight } from '@app/client';

interface WeightConfigProps {
    handleChange: (e: ChangeEvent<HTMLInputElement>, name: string, type: string) => void;
    newWeight: Weight;
    addConfigGroupOptions: (type: string) => void;
    deleteConfigGroupOption: (i: number, type: string) => void;
    weights: Weight[];
}

const WeightConfig = ({
    handleChange,
    newWeight,
    addConfigGroupOptions,
    deleteConfigGroupOption,
    weights,
}: WeightConfigProps) => {
    return (
        <div className="config-item">
            <div className="config-options">
                <Typography type="headline" size={18}>
                    Weight:
                </Typography>
                <br />
                <div className="input-container number">
                    <label
                        title="The lowest (inclusive) rhythm score range for inclusion when the probability spec hits"
                        htmlFor="weightMinScore"
                    >
                        Min Score:
                    </label>
                    <input
                        value={newWeight.min_score}
                        onChange={(e) => handleChange(e, 'min_score', 'weight')}
                        type="number"
                        name="min_score"
                        min={0}
                    />
                </div>
                <div className="input-container number">
                    <label
                        title="The highest (exclusive) rhythm score range for inclusion when the probability spec hits"
                        htmlFor="weightMaxScore"
                    >
                        Max Score:
                    </label>
                    <input
                        value={newWeight.max_score}
                        onChange={(e) => handleChange(e, 'max_score', 'weight')}
                        type="number"
                        name="max_score"
                        min={0}
                    />
                </div>{' '}
                <div className="input-container number">
                    <label
                        title="The inverse probability ratio. This is a 1:n value. i.e. an ipr of 5 means a 1 in 5 chance of occurring: 0, or 20%"
                        htmlFor="ipr"
                    >
                        Inverse Probability Ratio:
                    </label>
                    <input
                        value={newWeight.ipr}
                        onChange={(e) => handleChange(e, 'ipr', 'weight')}
                        type="number"
                        name="ipr"
                        min={0}
                    />
                </div>
                <div style={{ width: 200, margin: '20px 0' }}>
                    <Button
                        type="button"
                        onClick={() => addConfigGroupOptions('weight')}
                        size="small"
                        color="transparent"
                    >
                        Add Weighting
                    </Button>
                </div>
            </div>

            {weights.length > 0 && (
                <table className="lb-table">
                    <tbody>
                        <tr className="row-header type">
                            <td>min score</td>
                            <td>max score</td>
                            <td>ipr</td>
                            <td>del</td>
                        </tr>

                        {weights.map((w, i) => {
                            return (
                                <tr key={i + 'w'} className="type">
                                    <td>{w.min_score}</td>
                                    <td>{w.max_score}</td>
                                    <td>{w.ipr}</td>
                                    <td>
                                        <img
                                            onClick={() => deleteConfigGroupOption(i, 'weight')}
                                            className="close"
                                            src="/assets/icons/close-icon.svg"
                                            alt=""
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};
export default WeightConfig;
